<template>
  <div class="web_dialog">
    <Dialog
      :visible="dialogData.message !== '' && modalName === 'AppDialog'"
      :style="{width: `${dialogData.width}px`}"
      :modal="true"
      :closable="false"
    >
      <template #header>
        <h5>{{ dialogData.header }}</h5>
        <span
          v-if="isShowClose === 'show'"
          class="close_btn"
          @click="closeModal"
        />
      </template>

      <div class="confirmation-content">
        <slot name="content">
          <p class="modal_msg">
            {{ dialogData.message }}
          </p>
        </slot>
      </div>

      <template #footer>
        <Button
          v-if="dialogData.dialogType === 'confirm'"
          :label="dialogData.rejectLabel"
          class="small_btn"
          @click="closeModal"
        />
        <Button
          v-else-if="dialogData.dialogType === 'alert'"
          :label="dialogData.acceptLabel"
          :class="{ small_btn: dialogData.dialogType === 'confirm' }"
          @click="confirmAction"
        />
      </template>
    </Dialog>
  </div>
</template>

<script>
import { useStore } from 'vuex';
import { computed } from 'vue';
import Dialog from 'primevue/dialog';
import Button from 'primevue/button';

const closeStatusList = {
  alert: 'hide',
  alert_timer: 'hide',
  confirm: 'show',
  disabled_pop: 'hide',
  redirect: 'show'
};

export default {
  name: 'AppDialog',
  components: {
    Dialog,
    Button
  },
  props: {
    width: {
      type: [Number, String],
      default () {
        return 500;
      }
    },
    header: {
      type: String,
      default () {
        return '全支付提示訊息';
      }
    },
    message: {
      type: String,
      default () {
        return '';
      }
    },
    acceptLabel: {
      type: String,
      default () {
        return '確認';
      }
    },
    rejectLabel: {
      type: String,
      default () {
        return '取消';
      }
    },
    dialogType: {
      type: String,
      default () {
        // confirm 顯示兩顆紐
        // alert 顯示一顆按鈕 (帶入 acceptLabel)
        // notification 都不顯示按鈕
        return 'confirm';
      }
    }
  },
  emits: ['modal-action'],
  setup (props, { emit }) {
    const store = useStore();
    const modalName = computed(() => store.state.dialog.modalName);

    const dialogData = computed(() => {
      const returnData = {};

      Object.keys(props).forEach((item, key) => {
        returnData[item] = store.state.dialog.dialogItem[item] || props[item];
      });

      return returnData;
    });

    const isShowClose = computed(() => {
      const dialogType = dialogData.value.dialogType;
      const isShowCloseBtn = store.state.dialog.dialogItem.isShowCloseBtn;

      return isShowCloseBtn === '' ? closeStatusList[dialogType] : isShowCloseBtn;
    });

    const closeModal = () => {
      store.commit('CLOSE_DIALOG');
    };

    const confirmAction = () => {
      if (dialogData.value.dialogType === 'alert') {
        closeModal();
      } else {
        emit('modal-action', store.state.dialog.actionType);
      }
    };

    return {
      dialogData,
      closeModal,
      confirmAction,
      modalName,
      isShowClose
    };
  }
};
</script>

<style lang="scss" scoped>
@import '@/scss/common/common.scss';

.web_dialog {
  ::v-deep(.p-component-overlay) {
    background: rgba($black, 0.7);
  }

  ::v-deep(.p-dialog) {
    background: $white;
    border-radius: 12px;
    padding: 0px 50px;
    position: relative;
    max-width: 100%;

    .p-dialog-header {
      border-radius: 12px 12px 0px 0px;
      margin-bottom: 17px;
      padding: 37px 0px 0px;

      h5 {
        @include font-size-16;

        margin: 0px;
      }

      .close_btn {
        border-radius: 50%;
        background: url('~@/assets/imgs/close.png') no-repeat;
        background-size: 25px;
        color: $white;
        cursor: pointer;
        display: inline-block;
        font-size: 18px;
        height: 25px;
        line-height: 25px;
        position: absolute;
        right: 20px;
        text-align: center;
        top: 20px;
        width: 25px;
      }
    }

    .p-dialog-content {
      padding: 0;
      padding-top: 40px;

      .confirmation-content {
        display: flex;
        flex-direction: column;
        font-size: 20px;
        letter-spacing: 1.33px;
        line-height: 29px;
        justify-content: center;
        min-height: 95px;
        text-align: center;

        p {
          margin: 0;
        }
      }
    }

    .p-dialog-footer {
      border-radius: 0px 0px 12px 12px;
      margin-top: 20px;
      padding-bottom: 40px;
      text-align: center;

      .p-button {
        background: $black;
        border-radius: 6px;
        color: $white;
        font-size: 16px;
        font-weight: bold;
        line-height: 22px;
        padding: 11px 100px;

        &:last-of-type {
          margin-right: 0px;
        }

        &:focus {
          box-shadow: none;
        }
      }
    }
  }
}
</style>
